import { helper } from '@ember/component/helper';

export type ValidationError = {
  errors: string[];
  value: string;
  path: string;
};

/** Returns the matching Yup field errors, or an empty array when no error matches. */
function errorsForField(
  [field]: [string],
  { schemaErrors }: { schemaErrors: ValidationError[] }
): string[] {
  if ((!field && field !== '0') || !schemaErrors) {
    return [];
  }

  const error = schemaErrors.find((err) => {
    return err.path === field;
  });
  return error?.errors || [];
}

export default helper(errorsForField);
